"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@react-google-maps/api");
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Map_config_1 = require("./Map.config");
const MapDefaultCenterContext_1 = require("./MapDefaultCenterContext");
const MapLoader_1 = __importDefault(require("./MapLoader"));
const defaultCenter = {
    lat: -3.745,
    lng: -38.523,
};
const mapOptions = {
    streetViewControl: false,
    scaleControl: false,
    fullscreenControl: false,
    gestureHandling: 'greedy',
    mapTypeControl: true,
    mapTypeControlOptions: {
        position: 3,
    },
};
const MapWrapper = styled_components_1.default.div({
    backgroundColor: '#aadaff',
    // missing styles due to `preventGoogleFontsLoading`
    '.gm-style-moc': {
        backgroundColor: 'rgba(0,0,0,.45)',
        pointerEvents: 'none',
        textAlign: 'center',
        transition: 'opacity ease-in-out',
    },
    '.gm-style-mot': {
        color: 'white',
        fontSize: '22px',
        margin: 0,
        position: 'relative',
        top: '50%',
        transform: 'translateY(-50%)',
        // improve text positioning
        padding: '0 10px',
    },
});
const MapAbsoluteLoader = (0, styled_components_1.default)(MapLoader_1.default)({ position: 'absolute' });
const MAP_LIBRARIES = [`places`];
const MAP_LOADER_NODE = react_1.default.createElement(MapLoader_1.default, null);
const MapProvider = props => {
    const { children, styles, mapRef, onLoad = noop_1.default, options = {}, className } = props, mapProps = __rest(props, ["children", "styles", "mapRef", "onLoad", "options", "className"]);
    const { i18n: { language }, } = (0, next_i18next_1.useTranslation)();
    const providedDefaultCenter = (0, MapDefaultCenterContext_1.useMapDefaultCenter)();
    const { center: centerProp = providedDefaultCenter || defaultCenter } = props;
    // Prevent changing center if lat & lng are not changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const center = (0, react_1.useMemo)(() => centerProp, [centerProp.lat, centerProp.lng]);
    const onLoadHandler = (0, react_1.useCallback)(map => {
        onLoad(map);
        if (mapRef) {
            mapRef.current = map;
        }
    }, [mapRef, onLoad]);
    return (react_1.default.createElement(api_1.LoadScriptNext, { googleMapsApiKey: Map_config_1.googleMapKey, version: Map_config_1.googleMapVersion, loadingElement: MAP_LOADER_NODE, language: language, preventGoogleFontsLoading: true, libraries: MAP_LIBRARIES },
        react_1.default.createElement(MapWrapper, { className: className },
            react_1.default.createElement(MapAbsoluteLoader, null),
            react_1.default.createElement(api_1.GoogleMap, Object.assign({ zoom: 3, center: center }, mapProps, { options: Object.assign(Object.assign({}, mapOptions), options), mapContainerStyle: Object.assign({ position: 'absolute', background: 'transparent' }, styles), onLoad: onLoadHandler }), children))));
};
exports.default = MapProvider;
//# sourceMappingURL=MapProvider.js.map